import { memo } from 'react';

/**
 * Viewport-pinned Liquid Glass background layer.
 *
 * Renders a single fixed-position div behind all app content. Because it uses
 * `position: fixed; inset: 0` (no explicit height), it always matches the
 * visual viewport regardless of scroll length or keyboard state — fixing the
 * bug where the radial gradient stretched/flattened on long pages.
 */
function GlassBackgroundComponent() {
  return <div aria-hidden className="glass-bg-layer" />;
}

export const GlassBackground = memo(GlassBackgroundComponent);
